@if (valueFormGroup) {
  <fieldset>
    <legend>{{'export-creation.form.selectCalculationFuncParam.label' | translate}}</legend>
    <div class="flex interval-container">
      <app-dropdown
        [options]="options"
        [valueFormControl]="valueFormGroup.controls.dataTimeStepType"
        [fieldPlaceholder]="'export-creation.form.selectCalculationFuncParam.typeLabel' | translate">
      </app-dropdown>
      <app-numeric-input
        [valueFormControl]="valueFormGroup.controls.dataTimeStepRange"
        [minValue]="1"
        [placeholderValue]="'export-creation.form.selectCalculationFuncParam.valueLabel' | translate"
      ></app-numeric-input>
    </div>
  </fieldset>
}
